import { Theme } from "@mui/material";
import { SxObjType } from "lib/theme/types/SxObjType.type";

const sxStyles = (theme: Theme) => {
  return {
    mainContainer: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      // pb: theme.spacing(2), //16px
    },
    noticeContainer: {
      pt: 2,
      pl: 2,
      pr: 2,
      pb: 2,
    },
    divider: {
      marginTop: 2,
      marginBottom: 2,
      borderBottomWidth: 10,
      borderColor: theme.palette.secondary.main,
    },
  } satisfies SxObjType;
};

export { sxStyles };
